import {Injectable} from '@angular/core';

@Injectable()
export class CommandsGraphics3dScene {
    constructor() {

    }

    createSkyBox() {
    }

    loadSkyBox() {
    }

    setGravity() {
    }
}
